import React from "react";

export default function LiveTrackerSelector(props) {
    const type = props.type;
    const close = () => window.dispatchEvent(new CustomEvent('xs_closeModal', {detail: props.uniqueId}));

    function handleClick(e) {
        if (props.event == null) {
            return;
        }
        
        const rect = e.currentTarget.getBoundingClientRect();
        const position = {
            top: rect.top,
            left: rect.left
        };
        setTimeout(() =>
            window.dispatchEvent(new CustomEvent('xs_openTracker', {detail: {type, event: props.event, position}}))
        );
        close();
    }

    function handleDrop(e) {
        e.preventDefault();

        const data = e.dataTransfer.getData('text/plain');
        const rect = e.currentTarget.getBoundingClientRect();
        const position = {
            top: rect.top,
            left: rect.left
        };
        setTimeout(() =>
            window.dispatchEvent(new CustomEvent('xs_moveTracker', {detail: {position}}))
        );
        close();
    }

    function handleDragEnter(e) {
        e.preventDefault();
    }

    function handleDragOver(e) {
        e.preventDefault();
    }

    return (
        <div className="c_59">
            <div className="c_59_1">
                <div className="c_59_1_1" onClick={handleClick} onDrop={handleDrop} onDragEnter={handleDragEnter} onDragOver={handleDragOver}></div>
                <div className="c_59_1_1" onClick={handleClick} onDrop={handleDrop} onDragEnter={handleDragEnter} onDragOver={handleDragOver}></div>
                <div className="c_59_1_1" onClick={handleClick} onDrop={handleDrop} onDragEnter={handleDragEnter} onDragOver={handleDragOver}></div>
            </div>
        </div>
    );
}
